import {bindModal} from '../../components/Modal/IoC/bindModal';
import {bindTableModule} from '../../components/Table/IoC/bindYcTable';
import {bindSystemApp} from '../../core/system/bindSystem.app';
import {bindDataFilterModule} from '../../modules/data-filter/IoC/dataFilterModuleBinding';
import {ContainerBinder} from '../ContainerBinder';
import {bindCoreApp} from './bindings/app/bindCore.app';
import {bindCoreAppJrpc} from './bindings/app/bindCore.app.jrpc';

export const createRootContainerApp = () => {
  const container = ContainerBinder.createContainer();

  bindSystemApp({containerToBind: container});
  bindCoreApp(container);
  bindCoreAppJrpc(container);

  bindTableModule(container);
  bindDataFilterModule(container);
  bindModal(container);

  return container;
};
